export class DynamicDimensionsModel {
    private readonly _isDynamic: boolean;
    private readonly _minimumWidth: number | undefined;
    private readonly _maximumWidth: number | undefined;
    private readonly _minimumHeight: number | undefined;
    private readonly _maximumHeight: number | undefined;

    constructor(public readonly isDynamicDimension: boolean, public readonly minWidth?: number, public readonly maxWidth?: number, public readonly minHeight?: number, public readonly maxHeight?: number) {
        this._isDynamic = isDynamicDimension;
        this._minimumWidth = minWidth;
        this._maximumWidth = maxWidth;
        this._minimumHeight = minHeight;
        this._maximumHeight = maxHeight;
    }

    /**
     * @method isDynamic
     * @description Returns true if the dimension is dynamic, false otherwise.
     * @returns {boolean}
     */
    public get isDynamic(): boolean {
        return this._isDynamic;
    }

    /**
     * @method minimumWidth
     * @description Returns the minimum width of the dynamic dimension. If the dimension is not dynamic, returns undefined.
     * @returns {number | undefined}
     */
    public get minimumWidth(): number | undefined {
        return this._isDynamic ? this._minimumWidth : undefined;
    }

    /**
     * @method maximumWidth
     * @description Returns the maximum width of the dynamic dimension. If the dimension is not dynamic, returns undefined.
     * @returns {number | undefined}
     */
    public get maximumWidth(): number | undefined {
        return this._isDynamic ? this._maximumWidth : undefined;
    }

    /**
     * @method minimumHeight
     * @description Returns the minimum height of the dynamic dimension. If the dimension is not dynamic, returns undefined.
     * @returns {number | undefined}
     */
    public get minimumHeight(): number | undefined {
        return this._isDynamic ? this._minimumHeight : undefined;
    }

    /**
     * @method maximumHeight
     * @description Returns the maximum height of the dynamic dimension. If the dimension is not dynamic, returns undefined.
     * @returns {number | undefined}
     */
    public get maximumHeight(): number | undefined {
        return this._isDynamic ? this._maximumHeight : undefined;
    }
}